{
  "pagination": {
    "page": 0,
    "maxPage": 2,
    "maxItems": 2,
    "wsItemsPerPage": 100
  },
  "unreadMessagesCount": 2,
  "list": [
    {
      "id": 27,
      "upPid": "90 3 ICM8 icmnlsdb10 UniusPrint59 26 A1001001A21K15B11428I7169818 A21K15B11428I716981 14 1034",
      "policyNumber": "7600191867",
      "claimNumber": null,
      "mailSubj": "Zmena - Moj domov",
      "mailBody": "\nVazena klientka, vazeny klient,\n\nv prilozenom dokumente Vam zasielame nove informacie k poistnej zmluve cislo 7600191867.\n\nAk vyuzivate nasu sluzbu Elektronickej komunikacie, prilozeny dokument si otvorite s pouzitim svojho hesla. Ak ste si nezvolili vlastne heslo, dokument otvorite zadanim Vasho rodneho cisla (bez lomky). Heslo si mozete zmenit cez www.allianz.sk/ek\n\nAktualne informacie o svojich poistkach a poistnych udalostiach, ako aj uzitocne online sluzby, najdete na portali Moj Allianz. Pristup na portal ziskate jednoducho - zalozenim online konta na https://online.allianz.sk/platobna-brana/OGU5NDRmMDZkNzZkMjYwMzJjMThmNzU5NDQ3OGE1ZTRfNzAwNzcxMzQ2XzE1Ni42RVVSXzNfX0NQX21vbmlrYS5sZWNrZXNpb3ZhQGFsbGlhbnouc2s%3D\n\n\nS pozdravom\n\nAllianz - Slovenska poistovna\n\n\nUpozornenie\nTato sprava je doverna a urcena len pre adresata. Pokial sprava nebola urcena Vam, nie ste opravneny ju pouzit ani dalej rozsirovat a bezodkladne informujte o doruceni odosielatela.\n\nWarning\nThis e-mail and any files transmitted with it is intended solely for the use of the above named addressee and may contain confidential and/or privileged information. If you are not the intended recipient, please do not copy, use or disclose the contents of this communication to others and notify the sender promptly.",
      "mailFrom": "Allianz - Slovenska poistovna sprava_np@allianz.sk",
      "mailTo": "ekptest180@allianz.sk",
      "mailSend": "2021-11-15T10:14:25.579+01:00",
      "priorityId": 1,
      "typeLabel": "odoslan\u00fd email",
      "priorityLabel": "\u0161tandardn\u00e1",
      "directionLabel": "Allianz -\u003E AK Klient",
      "upItemId": "A1001001A21K15B11428I71698",
      "unread": true,
      "threadId": null,
      "dms2Actnumber": null,
      "dms2Secflag": null
    },
    {
      "id": 26,
      "upPid": "90 3 ICM8 icmnlsdb10 UniusPrint59 26 A1001001A21K15B11226E7169418 A21K15B11226E716941 14 1034",
      "policyNumber": "7600191867",
      "claimNumber": null,
      "mailSubj": "Poistka - Moj domov",
      "mailBody": "\nVazena klientka, vazeny klient,\n\nv prilozenom dokumente Vam zasielame nove informacie k poistnej zmluve cislo 7600191867.\n\nAk vyuzivate nasu sluzbu Elektronickej komunikacie, prilozeny dokument si otvorite s pouzitim svojho hesla. Ak ste si nezvolili vlastne heslo, dokument otvorite zadanim Vasho rodneho cisla (bez lomky). Heslo si mozete zmenit cez www.allianz.sk/ek\n\nAktualne informacie o svojich poistkach a poistnych udalostiach, ako aj uzitocne online sluzby, najdete na portali Moj Allianz. Pristup na portal ziskate jednoducho - zalozenim online konta na www.allianz.sk/moj-allianz\n\n\nS pozdravom\n\nAllianz - Slovenska poistovna\n\n\nUpozornenie\nTato sprava je doverna a urcena len pre adresata. Pokial sprava nebola urcena Vam, nie ste opravneny ju pouzit ani dalej rozsirovat a bezodkladne informujte o doruceni odosielatela.\n\nWarning\nThis e-mail and any files transmitted with it is intended solely for the use of the above named addressee and may contain confidential and/or privileged information. If you are not the intended recipient, please do not copy, use or disclose the contents of this communication to others and notify the sender promptly.",
      "mailFrom": "Allianz - Slovenska poistovna sprava_np@allianz.sk",
      "mailTo": "ekptest180@allianz.sk",
      "mailSend": "2021-11-15T10:12:25.410+01:00",
      "priorityId": 1,
      "typeLabel": "odoslan\u00fd email",
      "priorityLabel": "\u0161tandardn\u00e1",
      "directionLabel": "Allianz -\u003E AK Klient",
      "upItemId": "A1001001A21K15B11226E71694",
      "unread": false,
      "threadId": null,
      "dms2Actnumber": null,
      "dms2Secflag": null
    }
  ]
}
